// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"16":"928ac3f8","300":"928ac3f8","890":"928ac3f8"}[chunkId] + ".chunk.css";
};